import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ApprovalGuard } from './services/approvalGuard/ApprovalGuard.guard';
import { AuthDelivery } from './services/authDelivery/authDelivery.guard';
import { AuthGuard } from './services/authGuard/auth.guard';
import { AuthLoginGuard } from './services/authLoginGuard/authlogin.guard';

const routes: Routes = [

{
path: '',
loadChildren: () => import('./pages/footer/footer.module').then(m => m.FooterPageModule),
canActivate : [AuthGuard]
},
{
  path: 'delivery',
  loadChildren: () => import('./pages/delivery-footer/delivery-footer.module').then(m=>m.DeliveryFooterPageModule),
  // canActivate : [AuthGuard]
  },
// {
// path: 'entry',

// loadChildren: () => import('./pages/entry/entry.module').then( m => m.EntryPageModule)
// },


{
path: 'signup',
loadChildren: () => import('./pages/signup/signup.module').then( m => m.SignupPageModule),
canActivate : [AuthLoginGuard]

},
{
path: 'signup/:id',
loadChildren: () => import('./pages/signup/signup.module').then( m => m.SignupPageModule),
canActivate : [AuthGuard]

},
{
path: 'term',
loadChildren: () => import('./pages/term/term.module').then( m => m.TermPageModule)
},
// {
// path: 'privacy',
// loadChildren: () => import('./pages/privacy/privacy.module').then( m => m.PrivacyPageModule)
// },

  {
    path: 'approval',
    loadChildren: () => import('./pages/approval/approval.module').then( m => m.ApprovalPageModule),
    canActivate : [ApprovalGuard]

  },
  {
    path: 'dog-profile/:id',
    loadChildren: () => import('./pages/dog-profile/dog-profile.module').then( m => m.DogProfilePageModule),
     canActivate : [AuthGuard]

  },
  {
    path: 'pendingdog',
    loadChildren: () => import('./pages/dog-profile/dog-profile.module').then( m => m.DogProfilePageModule),
     canActivate : [AuthGuard]

  },
  {
    path: 'vet-prescribe/:dogId',
    loadChildren: () => import('./pages/vet-prescribe/vet-prescribe.module').then( m => m.VetPrescribePageModule),
    canActivate : [AuthGuard]

  },
  {
    path: 'vetprescribe/:user',
    loadChildren: () => import('./pages/vet-prescribe/vet-prescribe.module').then( m => m.VetPrescribePageModule),
    canActivate : [AuthGuard]

  },
  {
    path: 'vetprescribeconsult/:dogId/:type',
    loadChildren: () => import('./pages/vet-prescribe/vet-prescribe.module').then( m => m.VetPrescribePageModule),
    canActivate : [AuthGuard]

  },
  {
    path: 'dog-profile',
    loadChildren: () => import('./pages/dog-profile/dog-profile.module').then( m => m.DogProfilePageModule),
    canActivate : [AuthGuard]

  },
  {
    path: 'login',
    canActivate : [AuthLoginGuard],
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'otp/:code/:mobile/:hash',
    canActivate : [AuthLoginGuard],
    loadChildren: () => import('./pages/otp/otp.module').then( m => m.OtpPageModule)},
    {
    path: 'vet-prescribe/:dogId/:id',
    loadChildren: () => import('./pages/vet-prescribe/vet-prescribe.module').then( m => m.VetPrescribePageModule),
    canActivate : [AuthGuard]

  },
  {
    path: 'add-food',
    loadChildren: () => import('./pages/add-food/add-food.module').then( m => m.AddFoodPageModule),
    canActivate : [AuthGuard]
 
  },
  {
    path: 'add-food/:id',
    loadChildren: () => import('./pages/add-food/add-food.module').then( m => m.AddFoodPageModule),
    canActivate : [AuthGuard]

  },
  {
    path: 'add-accessory',
    loadChildren: () => import('./pages/add-accesory/add-accesory.module').then( m => m.AddAccesoryPageModule),
    canActivate : [AuthGuard]

  },
  {
    path: 'add-accessory/:id',
    loadChildren: () => import('./pages/add-accesory/add-accesory.module').then( m =>m.AddAccesoryPageModule),
    canActivate : [AuthGuard]

   },
  {
    path: 'food-handoff',
    loadChildren: () => import('./pages/food-handoff/food-handoff.module').then( m => m.FoodHandoffPageModule)
  },
  {
    path: 'food-details',
    loadChildren: () => import('./pages/food-details/food-details.module').then( m => m.FoodDetailsPageModule)
  },
  {
    path: 'notification-modal',
    loadChildren: () => import('./pages/notification-modal/notification-modal.module').then( m => m.NotificationModalPageModule)
  },
  {
    path: 'diagnosed',
    loadChildren: () => import('./pages/diagnosed/diagnosed.module').then( m => m.DiagnosedPageModule)
  },
  {
    path: 'privacy',
    loadChildren: () => import('./pages/privacy-modal/privacy-modal.module').then( m => m.PrivacyModalPageModule)
  },
  {
    path: 'term',
    loadChildren: () => import('./pages/term-modal/term-modal.module').then( m => m.TermModalPageModule)
  },
  {
    path: 'customer-presc-detail/:dogId/:id',
    loadChildren: () => import('./pages/customer-presc-detail/customer-presc-detail.module').then( m => m.CustomerPrescDetailPageModule)
  },
  {
    path: 'contact-list',
    loadChildren: () => import('./pages/contact-list/contact-list.module').then( m => m.ContactListPageModule)
  },

  {
    path: 'recording-modal',
    loadChildren: () => import('./pages/recording-modal/recording-modal.module').then( m => m.RecordingModalPageModule)
  },
  {
    path: 'test-record',
    loadChildren: () => import('./pages/test-record/test-record.module').then( m => m.TestRecordPageModule)
  },
  {
    path: 'remote-consulting/:id',
    loadChildren: () => import('./pages/remote-consulting/remote-consulting.module').then( m => m.RemoteConsultingPageModule)
  },
  {
    path: 'vets-new',
    loadChildren: () => import('./pages/vets-new/vets-new.module').then( m => m.VetsNewPageModule)
  },
  {
    path: 'bank-info',
    loadChildren: () => import('./pages/bank-info/bank-info.module').then( m => m.BankInfoPageModule)
  },

  {
    path: 'availability',
    loadChildren: () => import('./pages/availability/availability.module').then( m => m.AvailabilityPageModule)
  },
  {
    path: 'payment-history',
    loadChildren: () => import('./pages/payment-history/payment-history.module').then( m => m.PaymentHistoryPageModule)
  },
  {
    path: 'remote-complete/:consultingId/:consultingUserId',
    loadChildren: () => import('./pages/remote-complete/remote-complete.module').then( m => m.RemoteCompletePageModule)
  },
  {
    path: 'product-details',
    loadChildren: () => import('./pages/product-details/product-details.module').then( m => m.ProductDetailsPageModule)
  },


  {
    path: 'product-details/:type/:id',
    loadChildren: () => import('./pages/product-details/product-details.module').then( m => m.ProductDetailsPageModule)
  },

 
 


  // {
  //   path: 'delivery-profile',
  //   loadChildren: () => import('./pages/delivery-profile/delivery-profile.module').then( m => m.DeliveryProfilePageModule)
  // },
  // {
  //   path: 'delivery-footer',
  //   loadChildren: () => import('./pages/delivery-footer/delivery-footer.module').then( m => m.DeliveryFooterPageModule)
  // }
];
@NgModule({
imports: [
RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
],
exports: [RouterModule]
})
export class AppRoutingModule {}